import http from '@utils/http'

/*
* 获取用户信息
**/
export function getUserInfo(data): Promise<any> {
    return http.post('/login/getUserInfo', data || {})
}

/*
* 获取运营商id
**/
export function getOperatorId(data): Promise<any> {
    return http.post('/vodafone/getOperatorId', data || {})
}

/*
* 获取广告页配置
**/
export function getContentConfig(data): Promise<any> {
    return http.post('/podpage/getBannerMessage', data)
}

/*
* 优惠套餐-- 推荐的套餐列表
**/
export function getPackageConfig(data): Promise<any> {
    return http.post('/podpage/queryPlan', data)
}

/**
 * 获取所有的 可订购套餐列表
 * @param data
 */
export function getAvailProductData(data): Promise<any> {
    return http.post('/sim/queryPlan', data || {})
}
/**
 * 验证兑换码
 * @param data
 */
export function checkTicket(data): Promise<any> {
    return http.post('/activity/checkTicket', data || {})
}
/**
 * 获取兑换码详情
 * @param data
 */
export function getPackageByTicket(data): Promise<any> {
    return http.post('/activity/getGoods', data || {})
}
/*
* 根据兑换码获取套餐
**/
export function useTicket(data): Promise<any> {
    return http.post('/activity/useTicket', data || {})
}

/*
* 查询页面配置参数
**/
export function pageConfigQuery(data): Promise<any> {
    return http.post('/sim/queryConfig', data)
}

/*
* 优惠套餐
**/
export function getGuidePackageConfig(data): Promise<any> {
    return http.post('/podpage/queryPlanWithOutLogin', data)
}

/*
* 当月流量加油包订购记录
*/
export function getRefuelPackageOrderRecord(data): Promise<any> {
    return http.post('/sim/queryRefuelPackageOrderRecord', data)
}

/*
* 查询可订购加油包列表
*/
export function queryRefuelPackage(data): Promise<any> {
    return http.post('/sim/queryRefuelPackage', data)
}

/*
* 加油包订购接口
*/
export function buySpeedPlan(data): Promise<any> {
    return http.post('/sim/buySpeedPlan', data)
}
export function querySelectActive(data): Promise<any> {
    return http.post('/sim/querySelectActive', data)
}

export function getAuthCodeByICCID(data): Promise<any> {
    return http.post('/area/getAuthCodeByICCID', data)
}
/**
 * 查询赠送大礼包信息
 */
export function queryFreePackageInfo(data): Promise<any> {
    return http.post('/activity/queryFreePackageInfo', data)
}
/**
 * 关闭大礼包
 */
export function closePackagePrompt(data): Promise<any> {
    return http.post('/activity/closePackagePrompt', data)
}

export function addActiveQueue(data): Promise<any> {
    return http.post('/sim/addActiveQueue', data)
}
/**
 * 埋点测试
 */
export const sendEventTracing = (data) => http.post('/podpage/recordBehavior', data)
export const getSecurityKey = (data): Promise<any> => http.post('/login/getSecurityKey', data)

// 跳转小程序
export const generatorSchema = (data): Promise<any> => http.post('/podpage/generatorSchema', data)
// 分享链接跳转小程序
export const generatorSchemaGoodsReleaseId = (data): Promise<any> => http.post('/podpage/generatorSchemaGoodsReleaseId', data)
//查询信息
export const getByCode = (data): Promise<any> => http.post('/dongle/getByCode', data)
//获取二维码
export const generateQrCode = (data): Promise<any> => http.post('/dongle/generateQrCode', data)
// 查询宣传图
export const getQueryMsgPicture = (data): Promise<any> => http.post('/podpage/queryMsgPicture', data)
//公众号领取新人礼
export function receiveSubScribeGift(data): Promise<any> {
    return http.post('/podpage/receiveSubScribeGift', data)
}
//查询dongle新人是否添加客服
export function dongleGetControlFlag(data): Promise<any> {
    return http.post('/dongle/getControlFlag', data)
}
export function bindIccid(data): Promise<any> {
    return http.post('/login/BindIccid', data)
}

//每月签到
export function monthlySignGift(data): Promise<any> {
    return http.post('/podpage/monthlySignGift', data)
}
//wap每月签到周期查询
export function queryMonthlySignDetail(data): Promise<any> {
    return http.post('/podpage/queryMonthlySignDetail', data)
}
//每月签到记录
export function queryMonthlySignRecord(data): Promise<any> {
    return http.post('/podpage/queryMonthlySignRecord', data)
}

//回答问卷
export function answer(data): Promise<any> {
    return http.post('/dsr/answer', data)
}

//查询问卷
export function getAnswer(data): Promise<any> {
    return http.post('/dsr/getAnswer', data)
}

//流量活动领取
export function receiveAct(data): Promise<any> {
    return http.post('/dongle/receiveAct', data)
}

//终身流量活动领取
export function receiveActForPC(data): Promise<any> {
    return http.post('/dongle/receiveActForPC', data)
}

//流量活动领取记录
export function actCustLogList(data): Promise<any> {
    return http.post('/dongle/actCustLogList', data)
}

//问卷配置-查询问卷详情
export function getDsrDetail(data): Promise<any> {
    return http.post('/dsr/detail', data)
}